"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoCertificatesByFilter = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var NoCertificates_1 = require("./NoCertificates");

var _1 = require(".");

exports.NoCertificatesByFilter = function (_a) {
  var _b = _a.helpLinks,
      howToInstallCertificate = _b.howToInstallCertificate,
      serviceCenter = _b.serviceCenter,
      trackEvent = _a.trackEvent;

  var onInstallClick = function onInstallClick() {
    trackEvent(_1.DisplayedErrorCodes.NoCertificatesByFilter, 'howToInstallCertificateLinkClick');
  };

  var onServiceCenterClick = function onServiceCenterClick() {
    trackEvent(_1.DisplayedErrorCodes.NoCertificatesByFilter, 'serviceCenterLinkClick');
  };

  return {
    title: 'У вас на компьютере нет подходящих сертификатов',
    message: react_1.default.createElement("div", null, react_1.default.createElement(Link_1.Link, {
      "data-tid": "howToInstallCertificateLink",
      onClick: onInstallClick,
      href: howToInstallCertificate,
      target: "_blank"
    }, "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442"), ' ', "\u0438\u043B\u0438\xA0", NoCertificates_1.serviceCenterElement(serviceCenter, onServiceCenterClick), " \u0434\u043B\u044F\xA0\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430.")
  };
};